import {
	IsString,
	IsOptional,
	IsInt,
	IsBoolean,
	Min,
	Max,
} from "class-validator";
import { Type } from "class-transformer";

export class AbcCharacterSearchQueryDto {
	@IsOptional()
	@IsString()
	q?: string = '';

	@IsOptional()
	@IsBoolean()
	isPublished?: boolean;

	@IsOptional()
	@IsInt()
	@Min(1)
	@Type(() => Number)
	page?: number = 1;

	@IsOptional()
	@IsInt()
	@Min(1)
	@Max(100)
	@Type(() => Number)
	limit?: number = 24;
}
